module.exports = __webpack_public_path__ + "static/media/Family-disputes-01.5cb24c12.png";